import _extends from 'babel-runtime/helpers/extends';

import { mapState } from 'vuex';
import _ from 'lodash';
import { getDragonBonesImage, isDragonBones, isFrameSequence } from '@/views/creative/utils';
import { isLimitPlayItem, isHiddenCategory } from './tree.js';
import { v2Host } from '@/config/host';
import { getApiPath } from '@/common/api-proxy';
import { getFileExtension } from '@com/utils/file';
import { linkageMixin } from '../../mixin/linkage';
import { i18nCategoryResourceType, isPresetOptionCategory } from '@/store/creative/common/category';
import { addQueryString } from '@com/utils/url';

export default {
  props: ['node', 'data', 'sortType', 'treeName', 'isSceneNode', 'nodeAllowDrag'],
  mixins: [linkageMixin],
  computed: _extends({}, mapState({
    resourceList: function resourceList(state) {
      return state.creative.template.templateConfig.resource;
    },
    gameConfig: function gameConfig(state) {
      return state.creative.template.originalJson.gameConfig;
    },
    hasMvPlayable: function hasMvPlayable(state) {
      return state.creative.template.hasMvPlayable;
    },
    previewUrl: function previewUrl(state) {
      return state.creative.template.previewUrl;
    },
    refreshCover: function refreshCover(state) {
      return state.creative.template.refreshCover;
    },
    isCommonTemplatePage: function isCommonTemplatePage(state) {
      return state.creative.template.isCommonTemplatePage;
    }
  }), {
    category: function category() {
      return this.data;
    },
    resource: function resource() {
      return (_.get(this.resourceList, this.category.id) || []).find(function (item) {
        return item.is_default === 1;
      });
    },
    cocosModelProjectPreviewUrl: function cocosModelProjectPreviewUrl() {
      if (!this.previewUrl || !this.resource) return '';
      if (this.resource && this.resource.extra && this.resource.extra.thumb_url) {
        return this.resource.extra.thumb_url;
      }
      var baseUrl = '' + v2Host + getApiPath('/common/web/capture');
      var modelPreviewUrl = addQueryString(this.previewUrl, {
        model_preview: 1,
        model_path: this.resource.real_file_path,
        disabled_preview_reference: 1,
        disabled_preview_statistic: 1,
        disabled_preview_grid: 1,
        disabled_preview_operation: 1,
        disabled_preview_animation: 1,
        startup_config: 1
      });
      return addQueryString(baseUrl, {
        w: 100,
        url: modelPreviewUrl,
        t: 'model',
        force: this.refreshCover === this.resource.id ? 1 : 0
      });
    }
  }),
  methods: {
    isHiddenCategory: isHiddenCategory,
    canDrag: function canDrag(node) {
      return (this.treeName !== 'categoryTree' || this.treeName === 'categoryTree' && node.level > 1 && node.data.pid !== 9) && !isLimitPlayItem(node.data) && this.nodeAllowDrag(node.data);
    },
    getPopoverAttrs: function getPopoverAttrs(_ref) {
      var category = _ref.category;

      return {
        placement: 'left',
        trigger: 'hover',
        // disabled: !this.getCategoryDefaultImage(category),
        openDelay: 200
      };
    },
    getIcon: function getIcon(node) {
      if (node.resource_type === 'group' || isPresetOptionCategory(node)) {
        return 'cat_folder';
      }
      if (node.file_type === 'image' || isDragonBones(node.prefix) || isFrameSequence(node.prefix, node.resource_type)) {
        return 'cat_image';
      }
      if (node.file_type === 'audio') {
        return 'cat_audio';
      }
      if (node.file_type === 'video') {
        return 'cat_video';
      }
      if (node.resource_type === i18nCategoryResourceType) {
        return 'cat_word';
      }
      if (node.pid === 9) {
        return 'scenes';
      }
      if (this.gameConfig && this.gameConfig[node.prefix] && this.gameConfig[node.prefix].items) {
        return 'gameconfigfolder';
      }
      if (node.file_type === 'zip' && node.sub_resource_type === '3DModelCocos') {
        return 'ic_box';
      }
      return 'cat_others';
    },
    getCategoryDefaultImage: function getCategoryDefaultImage(category) {
      var defaultResource = (_.get(this.resourceList, category.id) || []).find(function (item) {
        return item.is_default === 1;
      });
      if (defaultResource) {
        if (isDragonBones(category.prefix)) {
          return getDragonBonesImage(defaultResource.preview_urls);
        }
        if (category.file_type === 'zip' && category.prefix.indexOf('model') !== -1) {
          return this.modelPreviewUrl(defaultResource.preview_urls);
        }
        if (category.file_type === 'zip' && defaultResource.sub_resource_type === '3DModelCocos') {
          return this.cocosModelProjectPreviewUrl;
        }
        if (category.file_type === 'zip') {
          return defaultResource.preview_urls[0];
        }
        if (category.file_type === 'image') {
          return defaultResource.file_url;
        }
        return '';
      }
      return '';
    },
    modelPreviewUrl: function modelPreviewUrl(previewUrls) {
      var baseUrl = '' + v2Host + getApiPath('/common/web/capture');
      var lmUrl = previewUrls.find(function (item) {
        return getFileExtension(item) === 'lm';
      });
      var texUrl = previewUrls.find(function (item) {
        return getFileExtension(item) !== 'lm';
      });
      var previewUrl = location.origin + '/lmpreview/3d.html?lmUrl=' + lmUrl + '&texUrl=' + texUrl;
      return baseUrl + '?url=' + encodeURIComponent(previewUrl) + '&w=200';
    }
  }
};